import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useDataProvider } from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import IconLibrary from '../IconLibrary';

function DispatchJobDialog({
  open,
  onClose,
  jobId,
  jobNumber,
  recordVersion,
  setError,
}) {
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, getApiUrl } = useDataProvider(provider);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const setDispatchErrors = apiResponse => {
    if (Array.isArray(apiResponse?.errors) && apiResponse?.errors.length > 0) {
      apiResponse?.errors?.forEach((error, index) => {
        setError(error?.path || `root.serverError${index}`, {
          message: error?.message || error?.detail || JSON.stringify(error),
        });
      });
    } else {
      setError(`root.serverError`, {
        message: 'Dispatch Advisor: Could not determine error',
      });
    }
  };

  const dispatchJob = async () => {
    const url = `${getApiUrl()}/sxcl/v1/service-jobs/${jobId}/operations/dispatch/validate?recordVersion=${recordVersion}`;
    const response = await get(url);

    return response;
  };

  const initialize = async () => {
    setLoading(true);
    const dispatchJobResponse = await dispatchJob();
    if (dispatchJobResponse?.ok) {
      navigate(`/servicejobs/dispatch/${jobId}`);
    } else {
      setDispatchErrors(dispatchJobResponse);
      setLoading(false);
      onClose();
    }
    setLoading(false);
  };

  useEffect(() => {
    initialize();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconLibrary.Dispatch />
        <FormattedMessage id="DISPATCH_JOB" defaultMessage="Dispatch Job" />
        &nbsp;&ndash;
        <Typography color="primary" variant="body">
          {jobNumber}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {loading && (
          <Box textAlign="center">
            <CircularProgress size="30px" />
            <Typography>
              <FormattedMessage
                id="JOB_DISPATCH_IN_PROGRESS"
                defaultMessage="Job dispatch in progress"
              />
              ...
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default DispatchJobDialog;
